import React, { useEffect, useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Grid,
  Paper,
  useMediaQuery,
  Button,
  FormHelperText,
} from "@mui/material";
import styled, { inputStyles } from "../../Utils/inputChanges";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { errorStyles } from "../../Utils/table";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchTeamLeader,
  updateTeamLeader,
} from "../../Store/PHPSlice/TeamLeader/TeamLeader";
import { selectTeamLeaderReg } from "../Selectors/Master/OutwardSelectors";


const TeamLeaderEdit = () => {
  const userdata = JSON.parse(localStorage.getItem("user"));
  const { Id } = useParams();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    teamId: parseInt(Id),
    teamLeaderNm: "",
    userId: userdata?.ID,
  });

  const [errors, setErrors] = useState({});

  // ✅ Use the same selector as your table
  const teamLeaderList = useSelector(selectTeamLeaderReg);

  // Fetch all team leaders on mount if not already fetched
  useEffect(() => {
    dispatch(fetchTeamLeader(Id));
  }, [dispatch, Id]);

  // Populate form after teamLeaderList is loaded
  useEffect(() => {
    if (teamLeaderList) {
      const record = teamLeaderList?.data;
      if (record) {
        setFormData((prev) => ({
          ...prev,
          teamLeaderNm: record?.teamLeaderNm,
        }));
      }
    }
  }, [teamLeaderList]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  const handleDateChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      dt: e.target.value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.teamLeaderNm.trim())
      newErrors.teamLeaderNm = "Team Leader Name is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
        const res = await dispatch(updateTeamLeader(formData)).unwrap();
         console.log("Team Leader updated:", res);

        if (res?.status === "success") {
          alert(res?.msg);
          window.close();
        } else {
          alert(res?.msg[0]);
        }
    } catch (error) {
      console.error("Update error:", error);
    }
  };

  const isDesktop = useMediaQuery("(min-width:768px)");

  return (
    <div style={{ margin: "1%" }}>
      <h2>Team Leader Edit</h2>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper style={{ padding: "3vh", margin: "0" }}>
            <Grid container spacing={2}>
              {/* Date */}
              {/* <Grid item xs={12} md={6}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item style={isDesktop ? { width: "30%" } : { width: "100%" }}>
                    <InputLabel htmlFor="dt">Date:</InputLabel>
                  </Grid>
                  <Grid item xs>
                    <FormControl fullWidth error={!!errors.dt}>
                      <TextField
                        id="dt"
                        name="dt"
                        type="date"
                        value={formData.dt}
                        onChange={handleDateChange}
                        inputProps={{ style: styled.inputDate }}
                        sx={inputStyles}
                      />
                      {errors.dt && <FormHelperText style={errorStyles}>{errors.dt}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid> */}

              {/* Team Leader Name */}
              <Grid item xs={12} md={6}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid
                    item
                    style={isDesktop ? { width: "30%" } : { width: "100%" }}
                  >
                    <InputLabel htmlFor="teamLeaderNm">
                      Team Leader Name:
                    </InputLabel>
                  </Grid>
                  <Grid item xs>
                    <FormControl fullWidth error={!!errors.teamLeaderNm}>
                      <TextField
                        id="teamLeaderNm"
                        name="teamLeaderNm"
                        value={formData.teamLeaderNm}
                        onChange={handleInputChange}
                        inputProps={{ style: styled.input }}
                        sx={inputStyles}
                      />
                      {errors.teamLeaderNm && (
                        <FormHelperText style={errorStyles}>
                          {errors.teamLeaderNm}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              {/* Submit */}
              <Grid item xs={12} textAlign="center">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
            <ToastContainer />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default TeamLeaderEdit;
